import { Typography } from '@neo4j-ndl/react';
import { Route, Routes } from 'react-router';

const variant = 'subheading-medium';
const className =
  "user-select-none overflow-hidden text-ellipsis whitespace-nowrap before:text-palette-neutral-border-strong before:font-sans before:text-sm before:font-bold before:content-['/'] before:mr-3";

export const OtherPagesNav = () => {
  return (
    <Routes>
      <Route
        path="orgs/*"
        element={
          <Typography variant={variant} className={className}>
            All organizations
          </Typography>
        }
      />
      <Route
        path="account/*"
        element={
          <Typography variant={variant} className={className}>
            Account
          </Typography>
        }
      />
      <Route path="*" element={null} />
    </Routes>
  );
};
